// Mirrors the backend _prefix() logic: strips protocol/slashes, replaces
// non-alphanumeric runs with hyphens, trims leading/trailing hyphens.
export function getPusherPrefix(): string {
  return window.location.host
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function notificationChannelName(userId: string | number): string {
  return `private-${getPusherPrefix()}-notifications-user-${userId}`;
}

export function companyChannelName(companyId: string | number): string {
  return `private-${getPusherPrefix()}-company-${companyId}`;
}

export const SUBSCRIPTION_LIMIT_EVENT = 'subcription_limit';
